import { useEffect, useState } from "react"
import { collection, collectionGroup, getDocs, orderBy, query, doc, getDoc } from "firebase/firestore"
import { db } from "../../../../services/firebase"

type Deposit = {
  userId: string
  asset: string
  amount: number
  timestamp?: any
}

type UserMap = Record<string, string>

const DepositsPanel = () => {
  const [deposits, setDeposits] = useState<Deposit[]>([])
  const [userMap, setUserMap] = useState<UserMap>({})

  useEffect(() => {
    const fetchData = async () => {
      // 1. Fetch users
      const usersSnap = await getDocs(collection(db, "users"))
      const map: UserMap = {}
      usersSnap.forEach(doc => {
        const data = doc.data()
        map[doc.id] = data.displayName || data.email || "Unknown"
      })
      setUserMap(map)

      // 2. Fetch deposits
      const q = query(collectionGroup(db, "deposits"), orderBy("timestamp", "desc"))
      const snap = await getDocs(q)

      const parsed = snap.docs.map(docSnap => {
        const data = docSnap.data()
        const userId = docSnap.ref.parent.parent?.id || "unknown"
        return { ...data, userId } as Deposit
      })

      setDeposits(parsed)
    }

    fetchData()
  }, [])

  return (
    <div className="admin-panel">
      <h2>Recent Deposits</h2>
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Asset</th>
            <th>Amount</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {deposits.map((d, i) => (
            <tr key={i}>
              <td>{userMap[d.userId] || d.userId}</td>
              <td>{d.asset}</td>
              <td>{d.amount}</td>
              <td>
                {d.timestamp?.toDate
                  ? d.timestamp.toDate().toLocaleString()
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DepositsPanel
